import { GetPartnerResponse } from "../../services/partner/get-partner/GetPartnerResponse";
import { Option } from "../../util/option";
import { DisplayColumn, ErrorMessage } from "../../util/spreadsheet-data-utils";
export type PartnerListPageState = {
  searchDepartmentId: string;
  searchResult: {
    partnerList: GetPartnerResponse[];
  };
  dipByRegionList: DipByRgn[];
  mergeMap: MergeMap[];
  dipByRgnDropdown: Option[];
  searchField: {
    dipByRgn: string;
    cpntId: string;
    ptnrCd: string;
    ptnrName: string;
  };
  dataList: DataList;
  fieldPath: FieldPath;
  isInitialized: boolean;
  displayColumn: DisplayColumn[];
};

export type SpreadSheetState = {
  partnerList: Partner[];
  deleteFlagCells: DeleteFlagCell;
  dataList: DataList;
};

export type Partner = {
  isEdited: boolean;
  partnerInfo: GetPartnerResponse;
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};

export type SpreadsheetState = {
  partnerList: Partner[];
  deleteFlagCells: DeleteFlagCell;
};

export type DipByRgn = {
  dipByRgn: string;
};

export type MergeMap = {
  childNum: number;
  parentNum: number;
};

export type DataList = {
  inDefCommonFlagType: Option[];
};

type FieldPath = {
  dipByRgn: string;
  cpntId: string;
  ptnrCd: string;
  ptnrName: string;
};

export type DeleteFlagCell = {
  [key: string]: {
    isDirty: boolean;
    initialValue: string;
    currentValue: string;
  };
};

export type PageNewState =
  | PartnerListPageState
  | ((prevState: PartnerListPageState) => PartnerListPageState);
